<template>
  <div>
    <LoadingOverlay
        :activeSyncProps="activeSync"
        :isFullPageProps="true"
    />
    <SignUpForm
        ref="inputFormAreaRef"
        @checkAllValidation="checkAllValidation"
    />
    <SignUpAgreement
        ref="agreementCheckAreaRef"
    />
    <a :class="pass ? 'blue pointer' : 'gray'"
       @click="signUp"
       class="btn btn_big no-drag mt10"
    >
      {{ $t('account.create_account') }}
    </a>
  </div>
</template>
<script>
import _API from '@/api';
import LoadingOverlay from "@/components/loadingOverlay/index";
import SignUpForm from './signUpForm';
import SignUpAgreement from './signUpAgreement';
import {
  toBlob,
} from "html-to-image";

export default {
  name: 'SignBody',
  components: {
    LoadingOverlay,
    SignUpForm,
    SignUpAgreement
  },
  data() {
    return {
      activeSync: false,
      pass: false, // 회원가입 api 를 요청해도 될지 여부
      requiredAgreements: 2 // 필수로 동의 받아야 하는 체크 박스의 총 갯수
    }
  },
  methods: {
    /**
     * 자식 컴포넌트의 모든 fields 의 validation 이 true 이면서, 필수 동의서에 체크했는 지 확인
     * @param booleans
     */
    checkAllValidation(booleans) {
      this.pass = booleans && (this.$refs.agreementCheckAreaRef.requiredAgreementsArr.length === this.requiredAgreements);
    },
    /**
     * 필수값인데, 입력되지 않은 input 에 빨강 경고 표시
     */
    checkIfNotEntered() {
      const fields = this.$refs.inputFormAreaRef.fields;
      fields.forEach((field, index_i) => {
        field.items.forEach((item, index_j) => {
            this.$refs.inputFormAreaRef.checkEachValidation(item, index_i, index_j)
        })
      })
    },
    /**
     *  서버에 회원가입 요청
     * @returns {Promise<void>}
     */
    async signUp() {
      if (this.pass) {
        this.activeSync = true;
        const fields = this.$refs.inputFormAreaRef.getFieldsValue();

        let formData = new FormData();
        await toBlob(document.getElementById('signImg1'))
            .then((file) => {
              formData.append('inputEmail', fields[0].items[1].value);
              formData.append('inputPw', fields[3].items[0].value);
              formData.append('inputName', fields[0].items[0].value);
              formData.append('file', file);
            })

        await _API.ACCOUNT.registerUser(formData).then(({data}) => {
          if (data.isSuccess) {
            this.$modal.show('common-alert-modal', {
              messageType: 'lineBreak',
              message: 'alert.check_email_authenticate'
            });
            this.$router.push(`/login`);
          } else {
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: 'alert.unexpected_error'
            });
          }
        }).catch((e) => {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.unexpected_error'
          });
          throw new Error(`[sighUpManager]${e}`);
        }).finally(() => {
          this.activeSync = false;
        });
      } else {
        this.checkIfNotEntered();
      }
    }
  }
}
</script>